<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>洗车监管系统</el-breadcrumb-item>
        <el-breadcrumb-item>消费统计</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="消费地点：">
              <el-select size="small" v-model="listParams.carWashSiteId" style="width: 100%" clearable>
                <el-option v-for="item in carWashSiteList" :label="item.title" :value="item.id" :key="item.id"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="16">
            <el-form-item label="下单日期：">
              <date-picker-group v-model="listParams.timeInterval"></date-picker-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="操作洗车工：">
              <el-input size="small" placeholder="请输入洗车工姓名" v-model="listParams.name"> </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-col :span="8">
              <el-form-item>
                <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" type="primary" size="small" @click="exportExcel"> 全部导出 </el-button>
          <span class="table-info-display">
            <span>合计：</span>
            <span class="alert-text ft16">￥{{ totalSum }}</span>
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column width="200" prop="consumeDate" align="center" label="消费日期">
          <template slot-scope="scope">
            <span>{{ scope.row.consumeDate | formatDate(true) }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="consumeSite" align="center" label="消费类型"> </el-table-column>

        <el-table-column prop="ticketsType" align="center" label="票券类型"> </el-table-column>

        <el-table-column prop="consumeNum" align="center" label="消费数量"> </el-table-column>

        <el-table-column prop="mobile" align="center" label="预留手机号"> </el-table-column>

        <el-table-column prop="operator" align="center" label="操作洗车工"> </el-table-column>

        <el-table-column prop="consumeSum" align="center" label="消费金额">
          <template slot-scope="scope">
            <span>￥ {{ scope.row.consumeSum }}</span>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
import { download } from "../../../../utils/javascript/download";

export default {
  data() {
    return {
      carWashId: "",
      listParams: {
        carWashSiteId: "",
        timeInterval: ["", ""],
        name: "",
      },
      carWashSiteList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      totalSum: 0,
      isDisabled: false,
    };
  },
  mounted() {
    this.carWashId = this.$route.params.carWashId;
    this.loadCarWashSiteList();
    this.loadTableData();
  },
  methods: {
    /**
     * 加载洗车点列表
     */
    loadCarWashSiteList() {
      this.$http({
        url: global.apiUrl + "/carwash/siteList?carWashId=" + this.carWashId,
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.carWashSiteList = res.body.data.dataList;
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 加载列表数据
     */
    loadTableData() {
      const bodyParams = Object.assign({}, this.listParams, {
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize,
        carWashId: this.carWashId,
      });
      bodyParams.startDate = bodyParams.timeInterval[0];
      bodyParams.endDate = bodyParams.timeInterval[1];
      delete bodyParams.timeInterval;
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/carwash/order/consumeList",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
              this.totalSum = res.body.data.totalSum;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 导出EXCEL
     */
    exportExcel() {
      const exportParams = Object.assign({}, this.listParams, {
        carWashId: this.carWashId,
      });
      exportParams.startDate = exportParams.timeInterval[0];
      exportParams.endDate = exportParams.timeInterval[1];
      delete exportParams.timeInterval;
      // this.$http.download({
      //   path: "/api/web/carwash/order/consumeListExport",
      //   query: exportParams,
      //   type: "excel"
      // });

      download("/carwash/order/consumeListExport", exportParams, "消费统计");
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
